export async function getContestacoes(
  distribuidor,
  periodo,
  ano,
  referencia,
  token
) {
  let myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);

  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  const apiUrl = `https://boanova183129.protheus.cloudtotvs.com.br:4050/rest/INT_SHELL_PEX_CONSULTACONTESTACAO?distribuidor=${distribuidor}&periodo=${periodo}&ano=${ano}&referencia=${referencia}`;

  try {
    const response = await fetch(apiUrl, requestOptions);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error ao pegar as contestacoes:", error);
  }
}
